import type { ITagRepository } from "@/application/ports/repositories";
import type { Tag, TagChanges, TagDraft, TagListQuery, TagRef } from "@/domain/tag";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class TagRepository implements ITagRepository {
  async listTags(query: TagListQuery, signal?: AbortSignal): Promise<Tag[]> {
    const response = await unwrap(
      sdk.listTags({ query: { search: query.search || undefined, sort: query.sort }, signal }),
    );
    return response.items;
  }

  async createTag(draft: TagDraft): Promise<Tag> {
    return unwrap(sdk.createTag({ body: draft }));
  }

  async updateTag(tagUuid: string, changes: TagChanges): Promise<Tag> {
    return unwrap(sdk.updateTag({ path: { tag_uuid: tagUuid }, body: changes }));
  }

  async deleteTag(tagUuid: string): Promise<void> {
    await unwrap(sdk.deleteTag({ path: { tag_uuid: tagUuid } }));
  }

  async replaceInvestorTags(investorUuid: string, tagUuids: string[]): Promise<TagRef[]> {
    const response = await unwrap(
      sdk.replaceInvestorTags({
        path: { investor_uuid: investorUuid },
        body: { tag_uuids: tagUuids },
      }),
    );
    return response.tags;
  }

  async replaceBeneficiaryTags(beneficiaryUuid: string, tagUuids: string[]): Promise<TagRef[]> {
    const response = await unwrap(
      sdk.replaceBeneficiaryTags({
        path: { beneficiary_uuid: beneficiaryUuid },
        body: { tag_uuids: tagUuids },
      }),
    );
    return response.tags;
  }
}
